<template>
  <div class="box vh-140">
    <div class="box-header">
      <i class="fa fa-th-large"></i>
      <h3 class="box-title">字典列表</h3>
    </div>
    <div class="box-body">
      <el-row class="margin-bottom-10" gutter="20">
        <el-col :span="18">
          <el-button type="primary" size="small" @click="toEdit()" plain><i class="fa fa-plus"></i> 添加字典</el-button>
          <el-button size="small" @click="toCategory" plain><i class="fa fa-ils"></i> 字典分类</el-button>
        </el-col>
      </el-row>
      <el-table class="list-table" :data="dictionaryList" border :stripe="true" style="width: 100%"
                :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
                :span-method="objectSpanMethod">
        <template slot="empty">
          <div class="no-data">暂无数据！</div>
        </template>
        <el-table-column prop="categoryName" label="分类" width="130"></el-table-column>
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="维度名称" min-width="120"></el-table-column>
        <el-table-column prop="contents" label="因子" min-width="320">
          <template slot-scope="scope">
            <el-tag type="" effect="plain" size="small" v-for="tag in scope.row.contents" :key="tag" style="margin-right: 5px;" >
              {{tag}}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="introduce" label="介绍" min-width="150"></el-table-column>
        <el-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" @click ="toEdit(scope.row.id)" size="small"><i class="fa fa-edit"></i> 编辑</el-button>
            <el-button type="text" @click.prevent="toDelete(scope.row.id)" size="small"><i class="fa fa-trash"></i> 删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <dictionary-save :visible="dictionaryDialog" :dictionary-id="id" @done="handleFinish"></dictionary-save>

    <dictionary-type :visible="typeDialog" @done="handleType"></dictionary-type>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {handleConfirm} from "@/utils/confirm";
import { fetchList,remove } from '@/api/rep/dictionary'
import DictionarySave from "./DictionarySave";
import DictionaryType from "./DictionaryType";


export default {
  name: 'dictionarl-list',
  components: {DictionarySave,DictionaryType},
  computed: {
    ...mapGetters(['user', 'company'])
  },
  data: function() {
    return {
      dictionaryList:[],
      id:null,
      typeDialog:false,
      dictionaryDialog:false,
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      fetchList().then(resp => {
        this.dictionaryList= resp.data.result
        this.dictionaryList.map(x=>{
          x.contents = JSON.parse(x.contents)
        })
      })
    },
    toEdit(val){
      console.info(val)
      this.id = val
      this.dictionaryDialog = true
    },
    handleFinish(flag = false){
      this.dictionaryDialog = false
      if (flag) {
        this.fetchData()
      }
    },
    handleType(flag = false){
      this.typeDialog = false
      if (flag) {
        this.fetchData()
      }
    },
    toCategory(){
      this.typeDialog = true
    },
    toDelete(id) {
      handleConfirm('此操作将删除该维度, 是否继续?').then(() => {
        remove(id).then(resp => {
          this.$message.success(resp.data.message);
          this.fetchData();
        })
      })
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if(columnIndex === 0){
        let array = this.dictionaryList.filter(o=>o.categoryId === row.categoryId)
        let idx = array.findIndex(o=>o.id == row.id)
        if(idx == 0){
          return  {rowspan:array.length,colspan:1}
        }else{
          return {rowspan: 0,colspan: 0}
        }
      }
    }
  },
}
</script>
